// BrandMarquee.js
import { Container } from "react-bootstrap";
import Marquee from "react-fast-marquee";
import { useGetAllClientsQuery } from "../../../../redux/api/ClientsApi/clientsApi";

const BrandMarquee = () => {
  const { data, isLoading } = useGetAllClientsQuery({
    limit: 100,
    sortBy: "display_order",
    order: "asc",
  });

  if (isLoading) {
    return null; // Or a spinner/skeleton if preferred
  }

  // Filter active clients
  const activeClients = (data?.data || []).filter((client) => client.status);

  if (activeClients.length === 0) return null;

  // Helper to chunk array
  const chunkArray = (array, size) => {
    const chunked = [];
    let index = 0;
    while (index < array.length) {
      chunked.push(array.slice(index, size + index));
      index += size;
    }
    return chunked;
  };

  // Split into rows if we have enough items, otherwise just one row
  const rows =
    activeClients.length > 8
      ? chunkArray(activeClients, Math.ceil(activeClients.length / 2))
      : [activeClients];

  return (
    <div style={{ background: "#fff", padding: "60px 0" }}>
      <Container>
        <h2 className="text-center fw-bold mb-5" style={{ color: "#009fe3" }}>
          Trusted by Top Brands
        </h2>

        {rows.map((row, index) => (
          <Marquee
            key={index}
            direction={index % 2 === 0 ? "left" : "right"}
            gradient={false}
            speed={30}
            pauseOnHover
            className="mb-4"
          >
            {row.map((client) => (
              <div
                key={client.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "150px",
                  height: "80px",
                  marginRight: "50px",
                }}
                title={client.client_name}
              >
                {client.client_logo && (
                  <img
                    src={client.client_logo}
                    alt={client.client_name}
                    style={{
                      maxHeight: "60px",
                      maxWidth: "100%",
                      objectFit: "contain",
                    }}
                  />
                )}
              </div>
            ))}
          </Marquee>
        ))}
      </Container>
    </div>
  );
};

export default BrandMarquee;
